import { TileWMS } from 'ol/source';
function tileWms({ url, params, serverType, transition, tileLoadFunction }) {
    return new TileWMS({
        url,
        params,
        serverType,
        transition,
        tileLoadFunction,
    });
}
export default tileWms;
